(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@bingads-webui-universal/observer-pattern"));
	else if(typeof define === 'function' && define.amd)
		define(["@bingads-webui-universal/observer-pattern"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@bingads-webui-universal/observer-pattern")) : factory(root["@bingads-webui-universal/observer-pattern"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__36__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 96);
/******/ })
/************************************************************************/
/******/ ({

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplacementStrategy = void 0;

/**
 * The base cache replacement strategy.
 */
class ReplacementStrategy {
  /**
   * Get the key of the cache entry to replace
   * @param {TimeAwareCache} cache - The cache to write with
   * @param {string} key - The key for the new cache entry
   * @param {number} timestamp - The timestamp of the write operation
   * @returns {string} - The key of the entry to replace
   */
  keyToReplace()
  /* cache, key, timestamp */
  {
    return null;
  }
  /**
   * Initialize the data structure to apply the strategy on a given cache
   * @param {TimeAwareCache} cache - The cache to work with
   * @returns {void}
   */


  initializeCache(cache) {
    cache.subscribe(this);
  }

}

exports.ReplacementStrategy = ReplacementStrategy;

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LRUReplacementStrategy = void 0;

var _base = __webpack_require__(100);

var _constants = __webpack_require__(102);

// Terms
// TLRU       - Time aware Least Recently Used
// LRU record - least recently used cache record
// LLT record - least life time cache record
// LRU chain  - a chain of all cache records in access sequence. The head of the
//              chain is the LRU record
// TTL heap   - a min-heap of all cache records according to their time to live.
//              the root of the heap is the LLT record
function validateLimit(limit) {
  if (typeof limit !== 'number' || Math.floor(limit) !== limit || limit <= 0) {
    throw new Error('Invalid limit');
  }
}
/**
 * The record for 1 cached key value pair
 * @typedef {Object} LRURecord
 * @property {string} key - The key for the object cached in the record
 * @property {number} exp - The expiration time
 * @property {LRURecord} next - Next record in LRU chain (more recently used)
 * @property {LRURecord} prev - Previous record in LRU chain (less recenlty used)
 */

/* eslint-disable no-param-reassign */

/**
 * Remove an LRU record from the chain
 * @private
 * @param {LRURecord} record - The record to remove
 * @returns {void}
 */


function removeLRURecord(record) {
  record.prev.next = record.next;
  record.next.prev = record.prev;
}
/**
 * Insert an LRU record into the chain before the anchor record
 * @private
 * @param {LRURecord} record - The record to insert
 * @param {LRURecord} anchor - The anchor record
 * @returns {void}
 */


function insertLRURecord(record, anchor) {
  anchor.prev.next = record;
  record.prev = anchor.prev;
  anchor.prev = record;
  record.next = anchor;
}
/* eslit-enable no-param-reassign */

/**
 * Promote an LRU record in the chain, mark it as most recently used
 * @private
 * @param {Object} lru - The TLRU cache state
 * @param {LRURecord} lru.records - The LRU records
 * @param {Object} lru.indices -
 *    The index hash, a mapping from cache key to record index
 * @param {string} key - The key of the record to be promoted
 * @returns {void}
 */


function promoteLRURecord(lru, key) {
  const records = lru.records,
        indices = lru.indices;
  const record = records[indices[key]];
  const pseudoRecord = records[0];

  if (record !== pseudoRecord && record !== pseudoRecord.prev) {
    removeLRURecord(record);
    insertLRURecord(record, pseudoRecord);
  }
}
/* eslint-disable no-bitwise, no-continue */

/**
 * Adjust the LRU records
 * @private
 * @param {Object} lru - The TLRU cache state
 * @param {LRURecord} lru.records - The LRU records
 * @param {Object} lru.indices - The mapping from cache key to record index
 * @param {string} key - The key of the record to be promoted
 * @returns {void}
 */


function adjustHeap(lru, key) {
  const records = lru.records,
        indices = lru.indices;
  let index = indices[key];

  while (index > 0 && index < records.length) {
    const record = records[index];
    const indexParent = index >> 1;
    const recordParent = indexParent > 0 ? records[indexParent] : null; // Shift up the record if it has less life time than parent

    if (recordParent && recordParent.exp > record.exp) {
      indices[record.key] = indexParent;
      indices[recordParent.key] = index;
      records[index] = recordParent;
      records[indexParent] = record;
      index = indexParent;
      continue;
    } // Choose the child with less life time


    const indexL = index << 1;
    const indexR = indexL + 1;
    const recordL = records[indexL] || null;
    const recordR = records[indexR] || null;
    const indexChild = recordR && recordR.exp < recordL.exp ? indexR : indexL;
    const recordChild = records[indexChild] || null; // Shift down the record if it has more life time than the child

    if (recordChild && recordChild.exp < record.exp) {
      indices[record.key] = indexChild;
      indices[recordChild.key] = index;
      records[index] = recordChild;
      records[indexChild] = record;
      index = indexChild;
      continue;
    }

    break;
  }
}
/* eslint-disable no-continue */


class LRUReplacementStrategy extends _base.ReplacementStrategy {
  /**
   * The Time aware Least Recently Used cache replacement strategy.
   * The replacement rules are
   *  1. If the LLT cache entry is expired, reuse it
   *  2. If the cache is not full, create a new entry
   *  3. Reuse the LRU cache entry
   * @extends ReplacementStrategy
   * @param {Object} options -
   * @param {number} options.limit - Maximum number of cache entries
   */
  constructor({
    limit = _constants.DEFAULT_LIMIT
  } = {}) {
    super();
    validateLimit(limit);
    this.limit = limit;
  }
  /**
   * Initialize the data structure to apply the strategy on a given cache
   * @override
   * @param {TimeAwareCache} cache - The cache to work with
   * @returns {void}
   */


  initializeCache(cache) {
    super.initializeCache(cache); // The pseudoRecord, doesn't hold any data, the purpose is
    // 1. Hold the head and tail of the LRU chain. Make the linked list a ring
    //    to simplify the logic.
    // 2. Take the index 0 of the TTL heap, to simplify the calculation of the
    //    index of the parent and the children in the heap.

    const pseudoRecord = {};
    pseudoRecord.next = pseudoRecord;
    pseudoRecord.prev = pseudoRecord;
    cache.lru = {
      // The TTL heap of the records, while the `next`, `prev` of the records
      // forms the LRU chain
      records: [pseudoRecord],
      // A map from the key to index in the TTL heap
      indices: {}
    };
  }
  /**
   * Get the key of the cache entry to replace, the rules are
   *  1. If the LLT entry is expired, reused it (return key of the LLT entry)
   *  2. If the cache is not full, allocate a new entry (return null)
   *  3. Reuse the LRU entry (return key of the LRU entry)
   * @override
   * @param {TimeAwareCache} cache - The cache to write with
   * @param {string} key - The key for the new cache entry
   * @param {number} timestamp - The timestamp of the write operation
   * @returns {string} - The key of the entry to replace
   */


  keyToReplace(cache, key, timestamp) {
    const _cache$lru = cache.lru,
          records = _cache$lru.records,
          indices = _cache$lru.indices; // Reuse the existing entry if the LRU record exists

    if (indices[key]) {
      return key;
    } // Reuse the LLT entry if it's already expired


    const recordLLT = records[1] || null;

    if (recordLLT && recordLLT.exp <= timestamp) {
      return recordLLT.key;
    } // Allocate a new entry if the cache is not full


    if (records.length <= this.limit) {
      return null;
    } // Reuse the LRU entry


    return records[0].next.key;
  }
  /**
   * Update the LRU records onGet
   * @override
   * @param {TimeAwareCache} cache - The cache being accessed
   * @param {number} timestamp - The timestamp of the operation
   * @param {CacheEntry} entry - The cache entry being read, null on cache miss
   * @returns {void}
   */


  onGet(cache, timestamp, {
    key,
    value,
    exp
  }) {
    if (value !== null && exp > timestamp) {
      promoteLRURecord(cache.lru, key);
    }
  }
  /**
   * Update the LRU records onSet
   * @override
   * @param {TimeAwareCache} cache - The cache being accessed
   * @param {number} timestamp - The timestamp of the operation
   * @param {CacheEntry} entry - The cache entry being written
   * @param {string} keyToReplace - The key of the replaced cache entry
   * @returns {void}
   */


  onSet(cache, timestamp, entry, keyToReplace) {
    const _cache$lru2 = cache.lru,
          records = _cache$lru2.records,
          indices = _cache$lru2.indices;

    if (keyToReplace) {
      const index = indices[keyToReplace];
      const record = records[index];
      record.key = entry.key;
      record.exp = entry.exp;
      delete indices[keyToReplace];
      indices[entry.key] = index;
      promoteLRURecord(cache.lru, entry.key);
    } else {
      const index = records.length;
      const record = {
        key: entry.key,
        exp: entry.exp
      };
      indices[entry.key] = index;
      records.push(record);
      insertLRURecord(record, records[0]);
    }

    adjustHeap(cache.lru, entry.key);
  }
  /**
   * Update the LRU records onGet
   * @override
   * @param {TimeAwareCache} cache - The cache being accessed
   * @param {number} timestamp - The timestamp of the operation
   * @param {CacheEntry} entry - The cache entry to delete, null on cache miss
   * @returns {void}
   */


  onDel(cache, timestamp, {
    key,
    value,
    exp
  }) {
    if (value !== null && exp > _constants.EXP_INVALIDATED) {
      const _cache$lru3 = cache.lru,
            records = _cache$lru3.records,
            indices = _cache$lru3.indices;
      const index = indices[key];
      const record = records[index];
      record.exp = _constants.EXP_INVALIDATED;
      adjustHeap(cache.lru, key);
    }
  }

}

exports.LRUReplacementStrategy = LRUReplacementStrategy;

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_LIMIT = exports.EXP_INVALIDATED = void 0;

/**
 * The expiration time for invalidated items
 * @constant {number}
 */
const EXP_INVALIDATED = -1;
exports.EXP_INVALIDATED = EXP_INVALIDATED;
const DEFAULT_LIMIT = 10;
exports.DEFAULT_LIMIT = DEFAULT_LIMIT;

/***/ }),

/***/ 36:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__36__;

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(97);


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TimeAwareCache", {
  enumerable: true,
  get: function get() {
    return _timeAwareCache.TimeAwareCache;
  }
});
Object.defineProperty(exports, "EXP_INVALIDATED", {
  enumerable: true,
  get: function get() {
    return _constants.EXP_INVALIDATED;
  }
});
Object.defineProperty(exports, "ReplacementStrategy", {
  enumerable: true,
  get: function get() {
    return _index.ReplacementStrategy;
  }
});
Object.defineProperty(exports, "UnlimitedReplacementStrategy", {
  enumerable: true,
  get: function get() {
    return _index.UnlimitedReplacementStrategy;
  }
});
Object.defineProperty(exports, "LRUReplacementStrategy", {
  enumerable: true,
  get: function get() {
    return _index.LRUReplacementStrategy;
  }
});
Object.defineProperty(exports, "defaultStrategy", {
  enumerable: true,
  get: function get() {
    return _index.defaultStrategy;
  }
});

var _timeAwareCache = __webpack_require__(98);

var _constants = __webpack_require__(102);

var _index = __webpack_require__(99);

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeAwareCache = void 0;

var _observerPattern = __webpack_require__(36);

var _index = __webpack_require__(99);

var _constants = __webpack_require__(102);

function validateTTL(ttl) {
  if (typeof ttl !== 'number' || ttl <= 0) {
    throw new Error('Invalid TTL');
  }
}

function validateKey(key) {
  if (typeof key !== 'string') {
    throw new Error('Invalid key');
  }
}

function validateValue(value) {
  if (typeof value === 'undefined' || value === null) {
    throw new Error('Invalid value');
  }
}

function stubEntry(key) {
  return {
    key,
    value: null,
    exp: _constants.EXP_INVALIDATED
  };
}
/**
 * Observer of cache read/write/delete events
 * @typedef {Object} CacheObserver
 * @property {CacheOnGetCallback} onGet - Callback on cache read operations
 * @property {CacheOnSetCallback} onSet - Callback on cache write operations
 * @property {CacheOnDelCallback} onDel - Callback on cache delete operations
 */

/**
 * Callback on cache read operations
 * @callback CacheOnGetCallback
 * @param {TimeAwareCache} cache - The cache being accessed
 * @param {number} timestamp - The timestamp of the operation
 * @param {CacheEntry} entry - The cache entry being read. On cache miss, it
 *    will be a fake entry with the accessing key and a null value.
 * @returns {void}
 */

/**
 * Callback on cache write operations
 * @callback CacheOnSetCallback
 * @param {TimeAwareCache} cache - The cache being accessed
 * @param {number} timestamp - The timestamp of the operation
 * @param {CacheEntry} entry - The cache entry being written
 * @param {string} keyToReplace - The key of the replaced cache entry
 * @returns {void}
 */

/**
 * Callback on cache delete operations
 * @callback CacheOnDelCallback
 * @param {TimeAwareCache} cache - The cache being accessed
 * @param {number} timestamp - The timestamp of the operation
 * @param {CacheEntry} entry - The cache entry to delete, null on cache miss
 * @returns {void}
 */

/**
 * A key-value cache with a TTL attached to each item
 */


class TimeAwareCache extends _observerPattern.Subject {
  /**
   * @param {Object} options -
   * @param {number} [options.ttl=Infinity] -
   *    The default TTL for items in this cache in milliseconds.
   * @param {CacheStrategy} [options.strategy=defaultStrategy] -
   *    The cache replacement strategy.
   *    Default to an instance of UnlimitedCacheStrategy.
   */
  constructor({
    ttl = Infinity,
    strategy = _index.defaultStrategy
  } = {}) {
    super();
    validateTTL(ttl);
    this.ttl = ttl;
    this.strategy = strategy;
    this.entries = {};
    strategy.initializeCache(this);
  }
  /**
   * Read value for given key from cache
   * @param {string} key - The key to access
   * @returns {Object} - The value associated with the key
   */


  get(key) {
    validateKey(key);
    const timestamp = Date.now();
    const entry = this.entries[key] || null;
    this.notify('onGet', timestamp, entry || stubEntry(key));
    return entry && entry.exp > timestamp ? entry.value : null;
  }
  /**
   * Write a key/value pair to cache
   * @param {string} key - The key of to write
   * @param {Object} value - The value to write
   * @param {number} ttl - The time for the key/value pair to live in milliseconds
   * @returns {void}
   */


  set(key, value, ttl = this.ttl) {
    validateKey(key);
    validateValue(value);
    validateTTL(ttl);
    const timestamp = Date.now();
    const entry = this.entries[key] || null;
    const keyToReplace = entry ? key : this.strategy.keyToReplace(this, key, timestamp);
    const entryNew = {
      key,
      value,
      exp: timestamp + ttl
    };

    if (keyToReplace && keyToReplace !== key) {
      delete this.entries[keyToReplace];
    }

    this.entries[key] = entryNew;
    this.notify('onSet', timestamp, entryNew, keyToReplace);
  }
  /**
   * Delete a key/value pair from cache
   * @param {string} key - The key to remove
   * @returns {void}
   */


  del(key) {
    validateKey(key);
    const timestamp = Date.now();
    const entry = this.entries[key] || null;

    if (entry) {
      delete this.entries[key];
    }

    this.notify('onDel', timestamp, entry || stubEntry(key));
  }
  /**
   * Purge all the expired entries
   * @returns {void}
   */


  purge() {
    const timestamp = Date.now();
    Object.keys(this.entries).forEach(key => {
      if (this.entries[key].exp <= timestamp) {
        this.del(key);
      }
    });
  }

}

exports.TimeAwareCache = TimeAwareCache;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReplacementStrategy", {
  enumerable: true,
  get: function get() {
    return _base.ReplacementStrategy;
  }
});
Object.defineProperty(exports, "LRUReplacementStrategy", {
  enumerable: true,
  get: function get() {
    return _lru.LRUReplacementStrategy;
  }
});
exports.defaultStrategy = exports.UnlimitedReplacementStrategy = void 0;

var _base = __webpack_require__(100);

var _lru = __webpack_require__(101);

/** @exports @bingads-webui/time-aware-cache */

/**
 * The unlimited cache replacement strategy class, assume the cache can have
 * unlimited entries
 * @extends ReplacementStrategy
 */
class UnlimitedReplacementStrategy extends _base.ReplacementStrategy {}

exports.UnlimitedReplacementStrategy = UnlimitedReplacementStrategy;
const defaultStrategy = new UnlimitedReplacementStrategy();
exports.defaultStrategy = defaultStrategy;

/***/ })

/******/ });
});
